// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://diywpnlgowjzavjcpehw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRpeXdwbmxnb3dqemF2amNwZWh3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU2ODc5OTcsImV4cCI6MjA3MTI2Mzk5N30.jySRD5jAR8V_4nmkJt5ur-M_B7GuHu1P2IaFW2sdy00";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});